/* RESPONSIBLE TEAM: team-frontend-tech */

import ENV from 'embercom/config/environment';
import type Route from '@ember/routing/route';
import type RouteInfo from '@ember/routing/route-info';

class FakeController {}

type ReactRoute = Route & { reactEnabled(): boolean };
type ReactRouteConstuctor = new (...args: unknown[]) => ReactRoute;
type _ReactRouteOptions = {
  overrideRenderTemplate?: boolean; // ⚠️⚠️⚠️ Do not use this unless you know what you're doing. See #team-frontend-tech for more information.
};

export const isReactRoute = (routeInfo?: RouteInfo) => {
  // hack to use parent root metadata if none on this route and parent is index
  if (!routeInfo?.metadata && routeInfo?.name.endsWith('.index')) {
    let metadata = routeInfo.parent?.metadata;
    return metadata && typeof metadata === 'object' && 'react' in metadata && metadata.react;
  }
  let metadata = routeInfo?.metadata;
  return metadata && typeof metadata === 'object' && 'react' in metadata && metadata.react;
};

/**
 * Wraps a route with behaviour to support rendering the React app
 *
 * @param superclass The Ember route that should be wrapped
 * @param options ⚠️⚠️⚠️ Advanced use only ⚠️⚠️⚠️ — Do not use unless you know what you're doing. See #team-frontend-tech for more information.
 */
export const ReactRoute = (superclass: ReactRouteConstuctor, options: _ReactRouteOptions = {}) => {
  options = {
    ...{
      overrideRenderTemplate: true,
    },
    ...options,
  };

  return class extends superclass {
    reactEnabled(): boolean {
      if (ENV.environment === 'test') {
        return false;
      }
      let app = super.modelFor('apps.app') as $TSFixMe;
      if (!app) {
        return false;
      }
      return super.reactEnabled();
    }

    buildRouteInfoMetadata() {
      return { react: this.reactEnabled() };
    }

    model(params: any, transition: any) {
      if (!this.reactEnabled()) {
        return super.model(params, transition);
      }
      return null;
    }

    setupController(controller: any, model: any, transition: any) {
      if (!this.reactEnabled()) {
        return super.setupController(controller, model, transition);
      }
    }

    renderTemplate() {
      let metadata = this.buildRouteInfoMetadata();

      if (metadata.react && options.overrideRenderTemplate) {
        let controller = new FakeController();

        // @ts-expect-error - Private API
        super.render('react-route', { controller });
      } else {
        // @ts-expect-error - Private API
        return super.renderTemplate(...arguments);
      }
    }
  };
};
